import { useEffect } from 'react';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export const useInitDatadog = () => {
  useEffect(() => {
    datadogRum.init({
      applicationId: '3e91b445-db98-4456-9869-273d42ae337c',
      clientToken: 'pub02a16e434e1516c0cf44f8f57eaeae97',
      site: 'us5.datadoghq.com',
      service: 'aqxtrader-web',
      env: 'prod',
      version: '3.4.0-2fbe797db',
      allowedTracingUrls: [
        (url) => {
          const urlObj = new URL(url);
          return urlObj.host === window.location.host;
        }
      ],
      traceSampleRate: 25,
      sessionSampleRate: 25,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      trackSessionAcrossSubdomains: true,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: false })]
    });

    datadogLogs.init({
      clientToken: 'puba43074bd12e6f5acb96dc0d1612145a8',
      site: 'us5.datadoghq.com',
      forwardErrorsToLogs: true,
      sessionSampleRate: 25
    });
  }, []);
};
